// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sale-page{padding-bottom:100px;padding-top:20px}.sale-page razlet-affiliator .home .pricing-form .pricing-form__switch,.sale-page razlet-affiliator .home .pricing-form .pricing-history__button{color:#003e92!important}.sale-page razlet-affiliator .home .pricing-form .pricing-form__switch svg,.sale-page razlet-affiliator .home .pricing-form .pricing-history__button svg{fill:#003e92!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
